import RoleEnum from '@/common/role.enum'

export default [
  RoleEnum.SUPER_ADMIN,
  RoleEnum.SUPERVISOR,
  RoleEnum.MANAGER
]
